/*
 * @Author: Dong
 * @Date: 2021-05-08 15:37:35
 * @LastEditors: Dong
 * @LastEditTime: 2021-05-08 15:37:56
 */
import React from 'react';

const LanguageContext = React.createContext();

export default LanguageContext;
